<template>
  <div class="win-container">
    <!-- 地块信息 -->
    <Modal
      :show="true"
      title=""
      width="420px"
      @close="close"
      v-if="infoType == 1"
    >
      <div
        slot="content"
        class="modal-content"
        style="padding: 8px 10px"
      >
        <div class="info-detail-item">
          <div class="label title-label" style="color: #FFFF9A;">{{detailInfo.plotName|| '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label" style="white-space: 	normal;width: 100%;">{{detailInfo.cooperationName}}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">地块面积(亩)</div>
          <div class="value">{{ detailInfo.plotArea || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">种植作物</div>
          <div class="value">{{ detailInfo.crops || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">创建日期</div>
          <div class="value">{{ detailInfo.createTime ? detailInfo.createTime.split(" ")[0] : '--' }}</div>
        </div>
      </div>
    </Modal>
    <Modal
      :show="true"
      title=""
      width="500px"
      :cooperativeTypes="detailInfo.cooperativeTypes"
      @close="close"
      v-if="infoType == 2"
    >
      <div
        slot="content"
        class="modal-content"
        style="padding: 10px 8px"
      >
        <img v-if="[3, 4].includes(detailInfo.status)" class="img-status" src="@/assets/img/cooperation/authed.png" alt="" />
        <img v-else class="img-status" src="@/assets/img/cooperation/un-authed.png" alt="" />

        <div class="info-detail-item">
          <div class="title-label" style="color: #FFFF9A;">{{detailInfo.cooperationName|| '--' }}</div>
        </div>
        <div class="info-detail-item" v-if="detailInfo && detailInfo.certType && (detailInfo.certType == 1 || detailInfo.certType == 2 || detailInfo.certType == 3)">
          <div class="title-label" style="color: #C4FFE1;">{{detailInfo.serviceName || '--' }}</div>
        </div>
        <div class="info-detail-item" style="align-items: flex-start;margin-top: 14px;">
          <div class="label" style="letter-spacing: 8px;">理事长</div>
          <div class="value">{{ detailInfo.presidentName || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">联系电话</div>
          <div class="value">{{ detailInfo.phone || '--' }}</div>
        </div>
        <div class="info-detail-item" style="align-items: flex-start;">
          <div class="label" style="letter-spacing: 30px;">地址</div>
          <div class="value" style="line-height: 20px;">{{detailInfo.address || '--'}}</div>
          <!-- <div class="label" style="white-space: 	normal;width: 100%;">{{detailInfo.address || '--'}}</div> -->
        </div>
        <div class="info-detail-item">
          <div class="label">农机总数</div>
          <div class="value">{{ detailInfo.vehicleCount || '0' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">社员人数</div>
          <div class="value">{{ detailInfo.userCount || '0' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">地块总面积(亩)</div>
          <div class="value">{{ detailInfo.plotArea || '0' }}</div>
        </div>
        <div class="info-detail-item" style="align-items: flex-start;padding: 4px 0">
          <div class="label" style="line-height: 20px;">当年作业类型及面积</div>
          <div class="value" style="line-height: 20px;overflow-wrap: break-word;">{{ detailInfo.jobTypeAndAmount && detailInfo.jobTypeAndAmount.length > 0 ? detailInfo.jobTypeAndAmount.join(',') : '--'}}</div>
        </div>

        <div class="tab-box" v-if="getTabs.length > 0">
          <p :style="{backgroundColor: activeTab == index ? 'rgba(0, 59, 31, 1)' : ''}" :class="getTabs.length == 1 ? 'onlyone' : ''" v-for="(item, index) in getTabs" @click="toggleActive(index)">{{item.name}}</p>
        </div>

        <!-- 烘干列表 -->
        <template v-if="activeTabObj && activeTabObj.name && detailInfo.capabilityObj">
          <template v-if="activeTabObj.name == '烘干能力'">
            <div class="info-table">
              <div class="thead">
                <span class="th">烘干类型</span>
                <span class="th">台数</span>
                <span class="th">日烘干能力（吨）</span>
              </div>
              <div class="tbody">
                <div v-for="item, index in detailInfo.capabilityObj.list3" :key="index" class="tr">
                  <span class="td">{{ item.abilityName || ''}}</span>
                  <span class="td" v-if="item.dryingInfo && item.dryingInfo.dryingCount >= 0">{{ item.dryingInfo.dryingCount || 0  }}</span>
                  <span class="td" style="text-align:center;" v-if="item.dryingInfo && item.dryingInfo.dryingCapacity">{{ item.dryingInfo.dryingCapacity || 0}}</span>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="info-table">
            <template v-if="detailInfo.capabilityObj && detailInfo.capabilityObj['list' + activeTabObj.id] && detailInfo.capabilityObj['list' + activeTabObj.id].length > 0">
              <div class="thead">
                <span class="th-emergency">{{activeTabObj.title[0] || ''}}</span>
                <span class="th-emergency" style="text-align: center;">{{activeTabObj.title[1] || '数量'}}</span>
              </div>
              <div class="tbody">
                <div v-for="(item, index) in detailInfo.capabilityObj['listObj' + activeTabObj.id]['arrNum']" :key="index" class="tr">
                    <span v-if="activeTabObj.id == 2" class="td-emergency">{{ item.abilityName }}</span>
                    <span v-else class="td-emergency">{{ item.abilityName + '('+ (item.unit || '台') +')' }}</span>
                    <span class="td-emergency" style="text-align: center;">{{ item.abilityValue }}</span>
                </div>
                <div v-for="(item, index) in detailInfo.capabilityObj['listObj' + activeTabObj.id]['arrStr']" :key="index" class="other">
                    <span class="label">{{ item.abilityName }}</span>
                    <span class="value">{{ item.abilityValue }}</span>
                </div>
                <!-- <div class="other" v-if="activeTabObj.name == '作业能力' && detailInfo.capabilityObj.list1[detailInfo.capabilityObj.list1.length - 1].abilityName == '其他装备数量及名称'">
                  <div class="label">其他装备数量及名称</div>
                  <div class="value">{{ detailInfo.capabilityObj.list1[detailInfo.capabilityObj.list1.length - 1].abilityValue || '0' }}</div>
                </div> -->
              </div>
            </template>
          </div> 
        </template>

      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@components/cooperativeModal.vue";
export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
    // 1合作社 2地块
    infoType: {
      type: Number,
      default: () => {
        return 2;
      },
    },
    vmm: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    'detailInfo.capabilityObj': {
      // deep: true,
      immediate: true,
      handler(val) {
        this.changeTabsStatus(val);
        this.handleWorkCapability(val);
      }
    }
  },
  data() {
    return {
      // 选中tab
      activeTab: 0,
      // 选中tab对象
      activeTabObj: null,
      tabs: [
        {
          id: 1,
          name: '作业能力',
          isShow: false,
          title: ['农机具', '数量'],
        },
        {
          id: 2,
          name: '应急能力',
          isShow: false,
          title: ['主要应急装备', '数量（台、套）'],
        },
        {
          id: 3,
          name: '烘干能力',
          isShow: false,
        },
        {
          id: 4,
          name: '调度能力',
          isShow: false,
          title: ['农机具', '数量'],
        },
      ],
      // 除去烘干类型的其他类型
      needFilter: [1,2,4],
      emergencyObj: {
        mobileDrying: '移动式烘干设备',
        grainHarvester: '谷物联合收割机',
        other: '其他应急装备',
        drying: '烘干设备',
        waterPump: '水泵',
        tractor: '拖拉机',
        irrigate: '排灌设备',
        sow: '播种机械',
        trackedHarvester: '履带式收割机',
        cornHarvester: '玉米收获机',
      }
    };
  },
  created() {},
  mounted() {},
  components: {
    Modal,
  },
  computed: {
    getTabs() {
      let arr = this.tabs.filter(item => item.isShow);
      this.activeTabObj = arr[0];
      return arr;
    },
  },
  methods: {
    close() {
      this.vmm.closeWindow();
    },
    // 选中tab
    toggleActive(index) {
      this.activeTab = index;
      this.activeTabObj = this.getTabs[index];
    },
    // 改变tabs状态
    changeTabsStatus(obj) {
      if(obj) {
        if(obj.selectCapabilityType1 && obj.selectCapabilityType1.length > 0) {
          this.tabs[0].isShow = true;
        }else {
          this.tabs[0].isShow = false;
        }
        if(obj.isCertEmergency == 1 && obj.certEmergencyDto.length > 0) {
          this.tabs[1].isShow = true;
        }else {
          this.tabs[1].isShow = false;
        }
        if(obj.isCertDrying == 1 && obj.certDryingDtos.length > 0) {
          this.tabs[2].isShow = true;
        }else {
          this.tabs[2].isShow = false;
        }
        if(obj.selectCapabilityType4 && obj.selectCapabilityType4.length > 0) {
          this.tabs[3].isShow = true;
        }else {
          this.tabs[3].isShow = false;
        }
      }else {
        this.tabs.forEach(item => {
          item.isShow = false
        })
      }
    },
    // 处理作业能力——其他装备数量及名称
    handleWorkCapability(obj) {
      const NUMERICAL_REG = /^-?\d+(\.\d+)?$/;
      // let arr = Object.assign([], obj.selectCapabilityType1 || []);
      this.needFilter.forEach(key => {
        if(obj['list' + key] && obj['list' + key].length > 0) {
          let arrNum = [];
          let arrStr = [];
          obj['list' + key].forEach(item => {
            if(item.abilityValue) {
              if(NUMERICAL_REG.test(item.abilityValue)) {
                arrNum.push(item);
              }else {
                arrStr.push(item);
              }
            }
          });
          obj['listObj' + key] = {};
          obj['listObj' + key]['arrNum'] = arrNum;
          obj['listObj' + key]['arrStr'] = arrStr;
        }
      })
    },
  },
};
</script>

<style scoped lang="scss">
.win-container {
  width: "460px";
}
.modal-content {
  .img-status {
    position: absolute;
    top: 46px;
    right: 94px;
  }
}
.info-title {
  margin: 5px 0px;
  color: #ffff9a;
  text-align: left;
  margin-left: -1em;
}
.info-detail-item {
  display: flex;
  line-height: 24px;
  align-items: center;
  .title-label {
    font-size: 14px;
  }
  .label {
    width: 96px;
    text-align: left;
    font-size: 14px;
    color: #C4FFE1;
    margin-right: 8px;
  }
  .value {
    color: #fff;
    line-height: 28px;
    text-align: left;
    flex: 1;
    font-size: 14px;
    display: flex;
  }
}


.tab-box {
  border-top: 1px solid #7BEDB5;
  border-bottom: 1px solid #7BEDB5;
  height: 29px;
  margin: 20px 0 10px 0;
  display: flex;
  align-items: center;
  font-family: Microsoft YaHei;
  font-size: 14px;
  color: #C4FFE1;
  p {
    flex: 1;
    text-align: center;
    height: 100%;
    line-height: 28px;
    cursor: pointer;
  }
  .onlyone {
    width: 33.3%;
    flex: none;
  }
}

.info-table {
  font-size: 14px;
  
  .thead {
    color: #ceffe1;
    background-color: #003B1F;
    display: flex;
    justify-content: space-around;
    padding: 4px 16px;
    .th {
      width: 23%;
      text-align: center;
      &:first-of-type {
        width: 28%;
        margin-right: 4px;
        text-align: left;
      }
      &:last-of-type {
        margin-left: 12px;
        text-align: left;
        flex: 1;
      }
    }
    .th-emergency {
      width: 20%;
      text-align: center;
      &:first-of-type {
        flex: 1;
        margin-right: 4px;
        text-align: left;
      }
      &:last-of-type {
        margin-left: 12px;
        text-align: left;
        width: 46%;
      }
    }
  }
  .tbody {
    .tr {
      color: #FFFFFF;
      padding: 4px 16px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      &:nth-child(even) {
        background-color: #2E674C;
      }
      .td {
        width: 23%;
        text-align: center;
        &:first-of-type {
          width: 28%;
          margin-right: 4px;
          text-align: left;

        }
        &:last-of-type {
          margin-left: 12px;
          flex: 1;
          text-align: left;

        }
      }
      .td-emergency {
        width: 20%;
        text-align: center;
        &:first-of-type {
          flex: 1;
          margin-right: 4px;
          text-align: left;

        }
        &:last-of-type {
          width: 46%;
          margin-left: 12px;
          text-align: left;

        }
      }
    }
    .other {
      display: flex;
      margin-top: 10px;
      font-size: 14px;
      .label {
        width: 96px;
        text-align: left;
        color: #C4FFE1;
        margin-right: 8px;
        line-height: 18px;
      }
      .value {
        color: #fff;
        text-align: left;
        flex: 1;
        display: flex;
        line-height: 18px;
      }
    }
  }
}
.line {
  height: 1px;
  background: #7BEDB5;
  margin: 16px -4px;
}
.info-detail-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .info-detail-item {
    width: 50%;
  }
}
</style>
